import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import { ScoutingAreaFilter } from "@/models/ScoutingArea";

export const SEARCH_AREAS = "search_areas";
export const SAVE_SCOUTING_AREA = "save_area";

@Component
export default class ScoutingAreaMixin extends Vue {
  readonly scoutingAreaPath =
    BASE_API_URL + "current_user/scouting/scouting_areas";

  search(payload: ScoutingAreaFilter) {
    const path = `${this.scoutingAreaPath}/search`;
    return this.$httpPost(path, SEARCH_AREAS, payload.toPostParams());
  }

  createScoutingArea(payload: any) {
    return this.$httpPost(this.scoutingAreaPath, SAVE_SCOUTING_AREA, payload);
  }
}
